"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useContinue = useContinue;
var RequestClearShoppingCache = _interopRequireWildcard(require("@ori-events/request-clear-shopping-cache"));
var RequestShoppingContextEvent = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _types = require("../../types");
var _utils = require("../../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
function useContinue({
  isOnlinePaymentMethod,
  isOrderReviewSkipped,
  selectedStep,
  setIsRegistrationVisible,
  setCurrentStep
}) {
  const {
    shoppingContext: {
      unitDataCollection = []
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const sessionId = (0, _shoppingContext.useSessionId)();
  const offers = unitDataCollection.filter(x => x.unitName === 'Offers');
  const [orderState, setOrderState] = (0, _react.useState)(_types.OrderState.None);
  const [errorCode, setErrorCode] = (0, _react.useState)(undefined);
  const [dialogMessage, setDialogMessage] = (0, _react.useState)(undefined);
  const [isFallbackRunning, setIsFallbackRunning] = (0, _react.useState)(false);
  const apiClient = (0, _globalApiClientReact.useApiClient)();
  const clearCacheEvent = new CustomEvent(RequestClearShoppingCache.Name);
  const shoppingContextRequestEvent = new CustomEvent(RequestShoppingContextEvent.Name);
  const {
    timer
  } = (0, _hooks.useFinaliseOrderFallback)({
    isFallbackRunning,
    setIsFallbackRunning,
    setOrderState,
    isOnlinePaymentMethod,
    isOrderReviewSkipped
  });
  function handleClose() {
    setErrorCode(undefined);
    setDialogMessage(undefined);
    window.dispatchEvent(clearCacheEvent);
    setTimeout(() => {
      window.dispatchEvent(shoppingContextRequestEvent);
    });
  }
  function onContinueClick() {
    if (selectedStep === _types.ShoppingStep.Basket && offers.length) {
      setCurrentStep(_types.ShoppingStep.Offers);
    } else {
      setCurrentStep(_types.ShoppingStep.Checkout);
    }
  }
  function onRegisterClick() {
    setIsRegistrationVisible(true);
  }
  async function onFinaliseOrderClick() {
    setOrderState(_types.OrderState.Pending);
    try {
      const result = await (0, _globalApiClientReact.createShoppingSessionOrder)(apiClient, sessionId);
      (0, _utils.clearShoppingContextCache)();
      setOrderState(_types.OrderState.Succeeded);
      const baseUrl = isOrderReviewSkipped && isOnlinePaymentMethod && typeof result.data.onlinePaymentId === 'number' ? `/finance/payment/ProcessPayment?onlinePaymentId=${result.data.onlinePaymentId}&clientApp=1` : `/shopping/order-confirm?orderId=${result.data.orderId}&onlinePaymentId=${typeof result.data.onlinePaymentId === 'number' ? result.data.onlinePaymentId : 0}`;
      window.location.replace(baseUrl);
    } catch (error) {
      const apiError = error;
      const apiErrorCode = apiError.response?.data.Errors[0]?.Code ?? undefined;
      if (apiError.code === 'ERR_NETWORK') {
        timer.current = _constants.PLACE_ORDER_FALLBACK_TIMEOUT;
        setIsFallbackRunning(true);
      } else if (apiErrorCode) {
        setErrorCode(apiErrorCode);
        setDialogMessage(_types.ErrorCodeTranslationMap[apiErrorCode]);
        setOrderState(_types.OrderState.Failed);
      } else {
        (0, _checkoutUtils.showErrorNotification)('genericError');
        setOrderState(_types.OrderState.Failed);
        window.dispatchEvent(clearCacheEvent);
        setTimeout(() => {
          window.dispatchEvent(shoppingContextRequestEvent);
        }, _checkoutUtils.errorNotificationTimeOut);
      }
    }
  }
  return {
    errorCode,
    dialogMessage,
    handleClose,
    isFallbackRunning,
    onContinueClick,
    onFinaliseOrderClick,
    onRegisterClick,
    orderState
  };
}